import axios from 'axios';

export const getSpeakingVideoList = async (page = 0, size = 25, sortBy = 'uploadedAt', sortDir = 'desc', userId = null, status = null, forceRefresh = false, fromDate = null, toDate = null) => {
  const params = {
    page: page,
    size: size,
    sortBy: sortBy,
    sortDir: sortDir
  };

  if (userId != null && userId !== '') {
    params.userId = userId;
  }

  if (status != null && status !== '') {
    params.status = status;
  }

  // Add date range filter only if both dates are provided
  if (fromDate != null && toDate != null) {
    params.fromDate = fromDate;
    params.toDate = toDate;
  }

  // Add cache busting parameter if force refresh
  if (forceRefresh) {
    params._t = Date.now();
  }

  try {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/speaking-video/list`, {
      params: params
    });
    return response;
  } catch (error) {
    console.error('Error fetching speaking video list:', error);
    throw error;
  }
};

export const submitFeedback = async (id, topicId, commentText, audioFile) => {
  try {
    const formData = new FormData();
    formData.append('id', id);
    if (topicId) {
      formData.append('topicId', topicId);
    }
    if (commentText) {
      formData.append('commentText', commentText);
    }
    if (audioFile) {
      formData.append('commentAudio', audioFile);
    }

    const response = await axios.post(`${process.env.VUE_APP_API_URL}/api/speaking-video/feedback`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
};

export const exportSpeakingVideos = async (sortBy = 'uploadedAt', sortDir = 'desc', userId = null, status = null, forceRefresh = false, fromDate = null, toDate = null) => {
  const params = {
    sortBy: sortBy,
    sortDir: sortDir
  };

  if (userId != null && userId !== '') {
    params.userId = userId;
  }

  if (status != null && status !== '') {
    params.status = status;
  }

  // Add date range filter only if both dates are provided
  if (fromDate != null && toDate != null) {
    params.fromDate = fromDate;
    params.toDate = toDate;
  }

  // Add cache busting parameter if force refresh
  if (forceRefresh) {
    params._t = Date.now();
  }

  try {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/speaking-video/exportList`, {
      params: params
    });
    return response;
  } catch (error) {
    console.error('Error fetching speaking video list:', error);
    throw error;
  }
};

export const getSpeakingVideoDetail = async (itemId) => {
  try {
    const formData = new FormData();
    formData.append('id', itemId);
    const params = {
      id: itemId
    };

    const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/speaking-video/getItemById`, {
      params: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  } catch (error) {
    console.error('Error fetching speaking video detail:', error);
    throw error;
  }
};

export default {
  getSpeakingVideoList,
  submitFeedback,
  exportSpeakingVideos,
  getSpeakingVideoDetail
};
